module.exports = __webpack_public_path__ + "static/media/pdf_file.b0c9c1ae.svg";